<mat-icon *ngIf="!!type" [svgIcon]="svgIcon"></mat-icon>
<div class="alert-block-content"><ng-content></ng-content></div>
<button *ngIf="dismissible"
        mat-icon-button
        [disableRipple]="true"
        class="close-button"
        (click)="onDismiss()"
        [attr.aria-label]="'Dismiss'">
    <mat-icon>close</mat-icon>
</button>
